export default __webpack_public_path__ + "static/xbox-series-x-282x431-efee6dfe7ec39c0ee463a3bf90f58fdd.png";